module.exports = __webpack_public_path__ + "static/media/logo-civa.0b5fb00f.svg";